<template>
  <UForm ref="formRef" :state="form" :schema="schema">
    <UFormField v-if="inspectionTemplateId"
      class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start" 
      :label="$t('inspection_templates.object_name')" 
      name="inspectionTemplateId">
      <p style="margin-top:-4px !important">{{ inspectionTemplateName }}</p>
    </UFormField>
    <UFormField v-else
      class="w-full mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start" 
      :label="$t('inspection_templates.object_name')" 
      name="inspectionTemplateId"
    >
      <UButtonGroup class="inspectionBatchButtonGroup w-full gap-0 ">
        <input
          v-model="treeB.filter.value"
          :ref="treeB.inputRef"
          type="text"
          :placeholder="$t('common.form_control.select_select')"
          style="font-size:14px !important;"
          @focus="treeB.toggleSearchTree"
          :class="(treeB.filter.value ? ' rounded-r-none !rounded-r-none ' :'' ) +
            ' w-full three-ac-form-control text-xs bg-white rounded-md focus:outline-none focus:ring-0 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-900' "
        /><ChevronDown id="iconDataEntryChevron" :class="chevronClassB" style="color:gray" />
        <UButton
          v-if="treeB.filter.value"
          icon="i-lucide-circle-x"
          variant="subtle"
          id="btnDataEntrySearchCleaner"
          class="cursor-pointer" color="neutral" 
          @click="treeB.filter.value = '';treeB.selectedNodes.value = []"
          :title="$t('common.tooltip.clear')"
          style="color:red;margin-top:0px !important;height:32px !important"
        />
      </UButtonGroup>
      <div v-if="treeB.showTree.value">
        <div
          :ref="treeB.treeRef"
          class="absolute right-0 mt-1 w-full md:min-w-[250px] md:max-w-[266px] bg-white  rounded shadow z-50"
          >
          <Tree id="" class="search-tree-3a" style="width: 100%;" 
            :value="treeB.filteredNodesValue.value" 
            v-model:selection-keys="treeB.selectedNodes.value"
            v-model:expanded-keys="treeB.expandedKeys"
            selectionMode="single" />
        </div>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 hidden sm:hidden md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>
    <UFormField
        class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
        :label="$t('inspection_batches.inspection_date')"
        name="fechaSalida"
      >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">
          {{ '--' }}
        </span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <UButtonGroup class="w-full">
          <UPopover>
            <UButton color="neutral" style="background-color:white"
              class="cursor-pointer w-full" variant="subtle" icon="i-lucide-calendar">
              {{ form.fechaSalida ? fechaSalidaDate : $t('common.form_control.datepicker_select') }} 
            </UButton>
            <template #content>
              <UCalendar v-model="form.fechaSalida" class="p-2" :locale="calendarLocale"/>
            </template>
          </UPopover>
          <UButton
            v-if="form.fechaSalida"
            icon="i-lucide-circle-x"
            variant="subtle"
            class="cursor-pointer" color="neutral" 
            @click="clearFecha()"
            title="Limpiar fecha"
            style="color:red"
          />
        </UButtonGroup>
      </div>
    </UFormField>
    <UFormField
        class="mb-3 grid grid-cols-1 md:grid-cols-[180px_62px] gap-0 md:gap-4 items-start"
        :label="$t('inspection_batches.inspection_hour')"
        name="horaSalida"
      >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">
          {{ '--' }}
        </span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5 max-w-[60px] ">
        <DatePicker id="datepicker-timeonly" v-model="form.horaSalida" class=" h-[32px]"  style="font-size:0.5rem !important"
          timeOnly fluid :manualInput="false" @click.stop showTime :modal="false" appendTo="self" :pt="{
            panel: { class: 'z-[49] ' }
          }"/>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 hidden sm:hidden md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>
    <UFormField 
      class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start" 
      :label="$t('suppliers.object_name')" 
      name="idSupplier"
    >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">
          {{ supplierOptions.find(option => option.value === form.idSupplier)?.label || '-' }}
        </span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <div v-if="loadingMaterials" class="py-1.5"><USkeleton class="h-4 w-[200px]"/></div>
        <USelect
          v-else
          v-model="form.idSupplier"
          :items="supplierOptions"
          option-attribute="label"
          value-attribute="value"
          placeholder="- Seleccionar -"
          class="w-full"
          color="neutral"
          :value="'-1'"
        />
      </div>
    </UFormField>

    <UFormField
      class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
      :label="$t('products.object_name')"
      name="idProduct"
      :error="selectedProductHasChildren ? undefined : (productMeasurementError ?? undefined)"
    >
      <div class="mt-0 md:-mt-2.5">
        <USelectMenu
          value-key="value"
          :items="productOptions"
          v-model="form.idProduct"
          v-model:open="productListIsOpen"
          option-attribute="label"
          value-attribute="value"
          @update:search-term="onProductSearch"
          @change="onProductChange"
          placeholder="- Seleccionar -"
          class="w-full"
          color="neutral"
          :search-input="{ placeholder: $t('common.form_control.uselectmenu_placeholder'), icon: 'i-lucide-search' }"
        />
      </div>
    </UFormField>

    <UFormField v-if="selectedProductHasChildren"
      class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
      :label="$t('parts.object_name')"
      name="idProductChild"
      :error="productMeasurementError ?? undefined"
    >
      <div class="mt-0 md:-mt-2.5">
        <div v-if="loadingChildrenProducts" class="py-1.5"><USkeleton class="h-4 w-[200px]"/></div>
        <USelectMenu v-else
          value-key="value"
          :items="productChildrenOptions"
          v-model="form.idProductChild"
          option-attribute="label"
          value-attribute="value"
          placeholder="- Seleccionar -"
          class="w-full"
          color="neutral"
          :search-input="{ placeholder: $t('common.form_control.uselectmenu_placeholder'), icon: 'i-lucide-search' }"
        />
      </div>
    </UFormField>

    <UFormField
      class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
      :label="$t('inspection_batches.photo')"
      name="photo"
    >
      <div class="mt-0 md:-mt-2.5">
        <input type="file" accept="image/jpeg,image/png,image/webp" class="text-xs" @change="onPhotoChange" />
        <div v-if="photoPreviewUrl" class="mt-2">
          <img :src="photoPreviewUrl" alt="" class="max-h-40 rounded border border-gray-200" />
        </div>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 hidden sm:hidden md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>

    <UFormField class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
       :label="$t('inspection_batches.supplier_po_number')"  name="purchaseOrder">
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">{{ form.purchaseOrder }}</span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <UInput v-model="form.purchaseOrder" class="w-full" color="neutral" type="text"/>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 hidden sm:hidden md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>
    <UFormField class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start" 
       :label="$t('inspection_batches.delivery_number')"  name="deliveryNumber">
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">{{ form.deliveryNumber }}</span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <UInput v-model="form.deliveryNumber" class="w-full" color="neutral"/>
      </div>
    </UFormField>
    <UFormField class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start" 
       :label="$t('inspection_batches.container_number')"  name="containerNumber">
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">{{ form.containerNumber }}</span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <UInput v-model="form.containerNumber" class="w-full" color="neutral"/>
      </div>
    </UFormField>
    
    <UFormField class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start" 
       :label="$t('inspection_batches.total_quantity_on_container')"  name="totalQuantityOnContainer">
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">{{ form.totalQuantityOnContainer }}</span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <UInput v-model="form.totalQuantityOnContainer" class="w-full" color="neutral" type="number"/>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 hidden sm:hidden md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>
    <UFormField class="text-xs mb-3 grid grid-cols-1  gap-0 md:gap-4 items-start"
       :label="$t('suppliers_materials.notes')"  name="notes">
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">{{ form.notes }}</span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        <UInput v-model="form.notes" class="w-full" color="neutral" :ui="{base: 'text-xs'}" />
      </div>
    </UFormField>

    <!-- Attributes v1 (nivel cabecera) -->
    <div v-if="attributeFieldsForm.length" class="mt-4">
      <div class="mb-2">
        <h3 class="text-sm font-semibold text-gray-800">{{ $t('inspections.attributes') }}</h3>
        <hr class="mt-2 border-gray-200" />
      </div>
      <div v-for="field in attributeFieldsForm" :key="field.key">
        <UFormField v-if="field.inputType === 'input'"
          class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
          :label="field.label" :name="field.key">
          <div class="mt-0 md:-mt-2.5">
            <UInput v-model="attrModel[field.key]" class="w-full" color="neutral"
              :type="field.dataType == 'string' ? 'text' : 'number'" :ui="{ base: 'text-xs' }" />
          </div>
        </UFormField>
        <UFormField v-else-if="field.inputType === 'checkbox'"
          class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
          :label="field.label" :name="field.key">
          <UCheckbox v-model="(attrModel[field.key] as boolean)" color="neutral" class="mt-0 md:-mt-1" />
        </UFormField>
        <UFormField v-else-if="field.inputType === 'select'"
          class="mb-3 grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] [&>*]:min-w-0 gap-0 md:gap-4 items-start"
          :label="field.label" :name="field.key">
          <div class="mt-0 md:-mt-2.5">
            <USelect v-model="(attrModel[field.key] as string)" :items="field.options || []"
              option-attribute="label" value-attribute="value" class="w-full text-xs" color="neutral" :value="'-1'" />
          </div>
        </UFormField>
      </div>
    </div>
  </UForm>
</template>

<script lang="ts" setup>
const { t: $t } = useI18n()

  import { ref } from 'vue'
  import { z } from 'zod'
  import { useDebounceFn } from '@vueuse/core'
  import type { Material } from '~/types/material';
  import type { Supplier } from '~/types/supplier';
  import type { Product } from '~/types/product';
  import type { InspectionBatch } from '~/types/data-entry/inspectionBatch';
  import Tree from 'primevue/tree'
  import { CalendarDate, DateFormatter, getLocalTimeZone } from '@internationalized/date'
  import DatePicker from 'primevue/datepicker';
  import { format } from 'date-fns'
  import { X, Search, Filter, ChevronDown, Tag, Download} from 'lucide-vue-next'

  const toast = useToast()
  const formRef = ref()
  const { t } = useI18n()
  const { locale } = useI18n() // reactive locale
  const { combineFechaHora, selectedTimezone } = useTimezoneDate()

  const form = reactive({
    fechaSalida: shallowRef<CalendarDate | null>(null),
    horaSalida: null as Date | null,
    //inspectionTemplateId: "" as string,
    idSupplier: "-1" as string,
    idProduct: "-1" as string,
    idProductChild: "-1" as string,
    purchaseOrder: "" as string,
    deliveryNumber: "" as string,
    containerNumber: "" as string,
    totalQuantityOnContainer: 0 as number,
    //isPreferred: "" as string,
    notes: "" as string,
  })

  // ---------------- Producto (cabecera, opcional) ----------------
  const productListIsOpen = ref(false)
  const productSearchTerm = ref('')
  const productSearchPageNumber = ref(1)
  const selectedProductHasChildren = ref(false)

  const productQueryParams = computed(() => ({
    pageNumber: productSearchPageNumber.value,
    pageSize: 20,
    parentProduct: 0,
    ...(productSearchTerm.value && { search: productSearchTerm.value })
  }))
  const productUrlWithParams = computed(() => `/product/paginate?${buildQueryString(productQueryParams.value)}`)
  const productChildrenUrl = computed(() => `/product/getChildProducts?hasChildren=false&productId=${form.idProduct}`)

  const { itemsPaginated: productDataResponse, loading: loadingProducts, load: loadProducts
        } = useCatalogoPlano<Product>('catalogo-products', productUrlWithParams, undefined, false, true)
  const { items: productChildrenDataResponse, loading: loadingChildrenProducts, load: loadChildrenProducts
        } = useCatalogoPlano<Product>('catalogo-products-children', productChildrenUrl)

  const productOptions = ref<{ label: string; value: string; hasChildren: boolean }[]>([{ label: $t('common.form_control.select_select'), value: '-1', hasChildren: false }])
  const productChildrenOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: '-1' }])

  function mapProductRecords(records: any[]) {
    return [
      { label: $t('common.form_control.select_select'), value: '-1', hasChildren: false },
      ...records.map((p: any) => ({
        label: `${p.partNumber ?? '(No Part Number)'} - ${p.name}`,
        value: String(p.id),
        hasChildren: p.hasChildren
      }))
    ]
  }

  const onProductSearch = useDebounceFn(async (term: string) => {
    if (!productListIsOpen.value) return
    productSearchTerm.value = term
    productSearchPageNumber.value = 1
    await loadProducts(true)
    productOptions.value = mapProductRecords(JSON.parse(JSON.stringify(productDataResponse.value?.records || [])))
  }, 350)

  async function onProductChange() {
    form.idProductChild = '-1'
    const sel = productOptions.value.find((p: any) => String(p.value) === form.idProduct)
    selectedProductHasChildren.value = sel?.hasChildren ?? false
    if (selectedProductHasChildren.value) {
      await loadChildrenProducts(true)
      productChildrenOptions.value = [
        { label: $t('common.form_control.select_select'), value: '-1' },
        ...(productChildrenDataResponse.value.map((p: any) => ({
          label: `${p.partNumber ?? '(No Part Number)'} - ${p.name}`,
          value: String(p.id)
        })) ?? [])
      ]
    }
  }

  // ---------------- Measurements en comun producto / template ----------------
  // Un producto sin ningun measurement en comun con el template no se puede inspeccionar
  // (el backend aplica la misma regla). Un padre con hijos se valida al elegir la parte.
  const measurementTemplateId = ref<number | null>(null)
  const templateMeasurementIds = ref<number[]>([])
  const productMeasurementError = ref<string | null>(null)

  const leafProduct = computed(() => {
    if (form.idProductChild && form.idProductChild !== '-1')
      return productChildrenOptions.value.find(p => p.value === form.idProductChild) ?? null
    if (form.idProduct && form.idProduct !== '-1' && !selectedProductHasChildren.value)
      return productOptions.value.find(p => p.value === form.idProduct) ?? null
    return null
  })

  let productMeasurementCheck = 0
  async function checkProductMeasurements() {
    productMeasurementError.value = null
    const product = leafProduct.value
    const templateId = measurementTemplateId.value
    if (!product || !templateId || !templateMeasurementIds.value.length) return

    const check = ++productMeasurementCheck
    const { data } = await useApiFetchObject<number[]>(
      `/productMeasurements/templateProduct/${templateId}/${product.value}`, { method: 'GET' })
    if (check !== productMeasurementCheck) return

    // success=false cuando el producto no tiene ninguna configuracion de measurements
    const productIds: number[] = (data.value as any)?.success ? ((data.value as any)?.data ?? []) : []
    if (!templateMeasurementIds.value.some(id => productIds.includes(id)))
      productMeasurementError.value = t('inspection_batches.message.product_without_template_measurements', { product: product.label })
  }

  watch([() => leafProduct.value?.value, measurementTemplateId], checkProductMeasurements)

  // ---------------- Foto del envio ----------------
  const ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp']
  const ALLOWED_PHOTO_EXT = ['jpg', 'jpeg', 'png', 'webp']
  const MAX_PHOTO_BYTES = 15 * 1024 * 1024

  const photoFile = ref<File | null>(null)
  const photoPreviewUrl = ref<string | null>(null)

  function clearPhoto(input?: HTMLInputElement) {
    if (input) input.value = ''
    photoFile.value = null
    if (photoPreviewUrl.value) {
      URL.revokeObjectURL(photoPreviewUrl.value)
      photoPreviewUrl.value = null
    }
  }

  function onPhotoChange(e: Event) {
    const input = e.target as HTMLInputElement
    const f = input.files?.[0] ?? null

    if (f) {
      const ext = f.name.split('.').pop()?.toLowerCase() ?? ''
      const isImage = ALLOWED_PHOTO_TYPES.includes(f.type) && ALLOWED_PHOTO_EXT.includes(ext)
      if (!isImage) {
        toast.add({
          title: $t('common.message.form_validation.default_error_message'),
          description: $t('inspection_batches.photo_invalid_type'),
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        })
        clearPhoto(input)
        return
      }
      if (f.size > MAX_PHOTO_BYTES) {
        toast.add({
          title: $t('common.message.form_validation.default_error_message'),
          description: $t('inspection_batches.photo_too_large'),
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        })
        clearPhoto(input)
        return
      }
    }

    photoFile.value = f
    if (photoPreviewUrl.value) URL.revokeObjectURL(photoPreviewUrl.value)
    photoPreviewUrl.value = f ? URL.createObjectURL(f) : null
  }
  onBeforeUnmount(() => { if (photoPreviewUrl.value) URL.revokeObjectURL(photoPreviewUrl.value) })

  const horaSalidaString = ref("");
  watch(() => form.horaSalida, (value) => {
    if (!value) return;
    horaSalidaString.value = value.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  });
  const fechaSalidaDate = computed(() => {
    if (!form.fechaSalida || typeof form.fechaSalida.toDate !== "function") return null;
    return df.value.format(form.fechaSalida.toDate(getLocalTimeZone()));
  });

  // DATE PICKER LOGIC
  const modelValue = shallowRef<CalendarDate | null>(null)
  const df = computed(() => {
    return new DateFormatter(locale.value, {
      dateStyle: 'long'
    })
  })
  const today = new Date()
  function clearFecha(): null {
    form.fechaSalida = null;
    return null;
  }
  const calendarLocale = computed(() => {
    return locale.value
  })

  const formatDateForBackend = (date: CalendarDate | null): string | null => {
    if (!date) return null
    return date.toDate(getLocalTimeZone()).toISOString()
  }
  // END OF DATE PICKER LOGIC
  
  // validación con zod
  const schema = z.object({ 
    fechaSalida: z.any()
      .refine(v => v && typeof v?.toDate === "function", {
        message: $t('inspection_batches.message.create.select_date')  
      }),
    horaSalida: z
      .date({
        required_error: $t('inspection_batches.message.create.select_time'),
        invalid_type_error: $t('inspection_batches.message.create.select_time')
      })
      .nullable()
      .refine(val => val !== null, {
        message: $t('inspection_batches.message.create.select_time')
      }),
    idSupplier: z.string({
        required_error: $t('common.message.form_validation.required'),
        invalid_type_error: $t('common.message.form_validation.must_select_option') 
      })
      .min(1, $t('common.message.form_validation.required'))
      .refine((val) => val !== "-1", { message: $t('common.message.form_validation.must_select_option')  }),
      
    purchaseOrder: z.string().min(1, t('common.message.form_validation.required')),
    deliveryNumber: z.string().min(1, t('common.message.form_validation.required')),
    containerNumber: z.string().min(1, t('common.message.form_validation.required')),
    totalQuantityOnContainer: z
      .number({ invalid_type_error: $t('common.message.form_validation.value_must_be_numeric') })
      .positive($t('common.message.form_validation.value_must_be_greater_than_zero')),
  })

  const { items: materialDataResponse, loading: loadingMaterials, load: loadMaterials
        } = useCatalogoPlano<Material>('catalogo-materials', '/material')
  
  const { items: supplierDataResponse, loading: loadingSuppliers, load: loadSuppliers
        } = useCatalogoPlano<Supplier>('catalogo-suppliers', '/supplier')
  
  const allowHidden = true;
  const treeB  = useDataEntryTree(allowHidden,locale,'iqa-data-entry-tree-cache-batches');
  const inspectionDateLabel = ref("");
  onMounted(async () => {
    if (isUpdate && id) {
      
      swal_loading();
      const [ { data } ] = await Promise.all([
        useApiFetchObject<InspectionBatch>(`/InspectionBatch/${id}`),
        loadMaterials(),
        loadSuppliers()
      ])

      const response = data.value?.data
      
      if (response) {
        form.idSupplier = String(response.supplierId);
        form.purchaseOrder = response.purchaseOrder;
        form.deliveryNumber = response.deliveryNumber;
        inspectionDateLabel.value = response.inspectionDate;
        form.containerNumber = response.containerNumber;
        form.totalQuantityOnContainer = response.quantity;
        //form.isPreferred = response.isPreferred;
        form.notes = response.notes;
      }
      swal_close();
    }
    else
    {
      await Promise.all([
        loadMaterials(),
        loadSuppliers()
      ]);
      const now = new Date()
      form.fechaSalida = new CalendarDate(
        now.getFullYear(),
        now.getMonth() + 1, // ⚠️ meses empiezan en 1
        now.getDate()
      ) 
      form.horaSalida = now
    }
    
    materialOptions.value = [
      { label: $t('common.form_control.select_select'), value: "-1" },
      ...(materialDataResponse.value
        .map((material) => ({
          label: material.name,
          value: String(material.id)
        })) ?? [])
    ];
    supplierOptions.value = [
      { label: $t('common.form_control.select_select'), value: "-1" },
      ...(supplierDataResponse.value
        .map((supplier) => ({
          label: supplier.name,
          value: String(supplier.id)
        })) ?? [])
    ];

    try {
      await loadProducts(true);
      productOptions.value = mapProductRecords(JSON.parse(JSON.stringify(productDataResponse.value?.records || [])));
    } catch (e) {
      // el producto en la cabecera es opcional
    }

    if (props.inspectionTemplateId && props.inspectionTemplateId > 0) {
      await loadTemplateAttributes(props.inspectionTemplateId);
    }

    swal_close();

    document.addEventListener('mousedown', treeB.handleClickOutside)
    treeB.expandTopNode();
    treeB.showTree.value = true;


  });
  
  onBeforeUnmount(() => {
    document.removeEventListener('mousedown', treeB.handleClickOutside);
  })
  
  const chevronClassB = computed(() => {
    const selectedKeys = Object.keys(treeB.selectedNodes.value);
    const base = 'pointer-events-none absolute top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400'
    const pos = treeB.filter.value && selectedKeys.length > 0 ? 'right-9' : 'right-3'
    return `${base} ${pos}`
  })

  const props = defineProps<{
    id: string,
    inspectionTemplateId: number | null,
    inspectionTemplateName?: string | null,
    isUpdate: boolean,
    isReadOnly: boolean
  }>();

  const materialOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])
  const supplierOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])

  const { id, inspectionTemplateId, inspectionTemplateName, isUpdate } = props
  const { isReadOnly } = toRefs(props)

  const emit = defineEmits<{
    (event: 'emit-from-component', id: string): void;
    (event: 'close-from-component'): void;
    (e: 'child-ready'): void // ✅ Add this line
  }>();

  const handleEmission = () => {
    emit('emit-from-component', props.id);
  }

  const handleClose = () => {
    emit('close-from-component');
  }

  // ---------------- Attributes v1 (nivel cabecera) ----------------
  // Se cargan segun el template seleccionado y se guardan en InspectionBatchAttributes.
  const { getCatalog } = useCatalogs();
  const attributeFieldsForm = ref<any[]>([]);
  const attrModel = reactive<Record<string, any>>({});

  async function loadTemplateAttributes(templateId: number) {
    attributeFieldsForm.value = [];
    measurementTemplateId.value = null;
    templateMeasurementIds.value = [];
    if (!templateId || templateId <= 0) return;
    try {
      const { data } = await useApiFetchObject<any>(
        `/inspectionTemplate/children?inspectionTemplateId=${templateId}`,
        { method: 'GET' }
      );
      const tpl = data.value?.data;
      measurementTemplateId.value = templateId;
      templateMeasurementIds.value = (tpl?.inspectionMeasurements ?? [])
        .filter((m: any) => !m.isDeleted)
        .map((m: any) => m.measurementId);
      const { attributeFields } = useInspectionFormBuilder(tpl);

      // catalogos para los de tipo select
      for (const f of attributeFields) {
        if (f.inputType === 'select' && f.catalog) {
          f.options = await getCatalog(f.catalog);
        }
      }

      for (const f of attributeFields) {
        if (!(f.key in attrModel)) {
          attrModel[f.key] = f.inputType === 'checkbox'
            ? (f.value === '1' || f.value === 'true')
            : (f.value ?? (f.inputType === 'select' ? '-1' : ''));
        }
      }
      attributeFieldsForm.value = attributeFields;
    } catch (e) {
      // sin atributos / template sin hijos
    }
  }

  function resolveSelectedTemplateId(): number | null {
    if (props.inspectionTemplateId && props.inspectionTemplateId > 0) return props.inspectionTemplateId;
    const keys = Object.keys(treeB.selectedNodes.value || {});
    if (!keys.length) return null;
    const node = treeB.findNodeByKey(treeB.nodes.value, keys[0]);
    if (!node || node.nodeType === 'TYPE' || node.type == undefined) return null;
    return Number(node.id) || null;
  }

  // Se dispara al seleccionar/cambiar el template en el arbol (rastrea las keys, primitivo => fiable).
  watch(
    () => Object.keys(treeB.selectedNodes.value || {}).join('|'),
    async () => {
      const tid = resolveSelectedTemplateId();
      if (tid) await loadTemplateAttributes(tid);
      else {
        attributeFieldsForm.value = [];
        measurementTemplateId.value = null;
        templateMeasurementIds.value = [];
      }
    }
  );

  function attrValueForSubmit(field: any): string {
    const v = attrModel[field.key];
    if (field.inputType === 'checkbox') return v ? 'true' : 'false';
    if (field.inputType === 'select') return (v == null || v === '-1') ? '0' : String(v);
    return v == null ? '' : String(v);
  }


  async function submitForm(): Promise<{success: boolean, message: string | null, data: {}}>
  {
    const inspectionTemplateId = ref(undefined as number | undefined);
    if(props.inspectionTemplateId) {
      inspectionTemplateId.value = props.inspectionTemplateId;
    }
    else
    {
      const keys = Object.keys(treeB.selectedNodes.value)
      //if (!keys.length) return false

      const selectedKey = keys[0]
      const node = treeB.findNodeByKey(treeB.nodes.value, selectedKey)

      if( node?.type == undefined )
      {
        toast.add({
          title: $t('inspections.template_selection_for_form_loading'),
          description: $t('common.message.form_validation.must_select_option'),
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        });
        return Promise.resolve({success: false, message: null, data: {}});
      }
      else if( node?.nodeType === 'TYPE' )
      {
        toast.add({
          title: $t('inspections.template_selection_for_form_loading'),
          description: $t('inspections.template_selection_error'),
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        });
        return Promise.resolve({success: false, message: null, data: {}});
      }
      if (!keys.length) 
        return Promise.resolve({success: false, message: null, data: {}});
      formRef.value?.submit();

      inspectionTemplateId.value = ref(node?.id);
    }//.fin de validación de selección de template

    const result = schema.safeParse(form);
    
    if (!result.success) {
      const firstError = Object.values(result.error.flatten().fieldErrors)[0]?.[0]
      toast.add({
        title: $t('common.message.form_validation.default_error_message'),
        description: firstError,
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      })
      return Promise.resolve({success: false, message: null, data: {}});
    }
    if (productMeasurementError.value) {
      toast.add({
        title: $t('common.message.form_validation.default_error_message'),
        description: productMeasurementError.value,
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      })
      return Promise.resolve({success: false, message: null, data: {}});
    }
    if(form.fechaSalida == null || form.horaSalida == null)
      return Promise.resolve({success: false, message: $t('common.message.form_validation.default_error_message'), data: {}});
    const fechaSalidaISO = combineFechaHora(form.fechaSalida, form.horaSalida);
    
    //return false;
    // Si se eligio un hijo (part), ese es el producto de la cabecera; si no, el seleccionado.
    const resolvedProductId = (form.idProductChild && form.idProductChild !== '-1')
      ? form.idProductChild
      : (form.idProduct && form.idProduct !== '-1' ? form.idProduct : '');

    const tplId = unref(inspectionTemplateId.value);

    const json_request = {
      ...(isUpdate && { id: id }),
      inspectionTemplateId: tplId,
      supplierId: form.idSupplier,
      productId: resolvedProductId ? Number(resolvedProductId) : null,
      purchaseOrder: form.purchaseOrder,
      deliveryNumber: form.deliveryNumber,
      containerNumber: form.containerNumber,
      inspectionDate: fechaSalidaISO,
      quantity: form.totalQuantityOnContainer,
      notes: form.notes,
      isActive: true,
    };

    try {
      swal_loading();
      let data: any, error: any;

      if (!isUpdate) {
        // La cabecera se crea como multipart/form-data porque la foto se sube con ella.
        const fd = new FormData();
        fd.append('InspectionTemplateId', String(tplId ?? ''));
        fd.append('SupplierId', form.idSupplier === '-1' ? '' : form.idSupplier);
        if (resolvedProductId) fd.append('ProductId', resolvedProductId);
        fd.append('PurchaseOrder', form.purchaseOrder ?? '');
        fd.append('DeliveryNumber', form.deliveryNumber ?? '');
        fd.append('ContainerNumber', form.containerNumber ?? '');
        fd.append('InspectionDate', fechaSalidaISO);
        fd.append('Quantity', String(form.totalQuantityOnContainer ?? 0));
        fd.append('Notes', form.notes ?? '');
        if (photoFile.value) fd.append('Photo', photoFile.value);
        if (attributeFieldsForm.value.length) {
          fd.append('AttributesJson', JSON.stringify(
            attributeFieldsForm.value.map((f: any) => ({
              inspectionAttributeTemplateId: f.id,
              attributeKey: f.key,
              attributeValue: attrValueForSubmit(f),
              dataType: f.dataType ?? 'string'
            }))
          ));
        }

        const res = await useApiUploadFile('/inspectionBatch/create', fd);
        data = { value: res.data };
        error = { value: res.error };
      } else {
        ({ data, error } = await useApiFetchObject<{ success: boolean; message: string, data: InspectionBatch | null }>(
          `/inspectionBatch/${id}/update`,
          {
            method: 'PUT',
            body: json_request
          }
        ));
      }
      if (error.value) {
        console.error("Error submitting:", error.value);
        // Mostrar alerta o toast aquí
      } else {
        
        emit('close-from-component');
        // Emit otro evento si deseas refrescar lista
      }

      if (error.value) { //Error de servidor, mostrar swal
        const serverMsg = data?.value?.message || error?.value?.message || $t('common.message.create.error');
        await swal_oops( serverMsg );
        //return new Promise((resolve) => {resolve(true);});
        return Promise.resolve({success: false, message: serverMsg, data: {}});
      }

      if (!data?.value?.success) { //Error de proceso, mostrar toast
        toast.add({
          title: $t('common.message.create.error'),
          description: data?.value?.message,
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        });
        return Promise.resolve({success: false, message: data?.value?.message as string, data: {}});
      }
      
      return Promise.resolve({success: true, message: data?.value?.message as string, data: data?.value?.data});
      

    } catch (err: any) {
      toast.add({
        title: $t('common.message.form_validation.unexpected_error'),
        description: err.message,
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      });
      return Promise.resolve({success: false, message: err.message, data: {}});
    }
  }

  defineExpose({ 
    submitForm,
  }) 
  
</script>

<style>
@media (max-width: 767px){
  .inspectionBatchButtonGroup{
    top:0px;
  }
  .inspectionBatchNavSearch{
    max-width:310px !important;
  } 
}
@media (min-width: 768px){
  .inspectionBatchButtonGroup{
    top:-9px !important;
  }
  .inspectionBatchNavSearch{
    max-width:268px !important;
    /*font-size: 14px !important;*/
  } 
}
.p-inputtext{
  font-size:14px !important;
  font-weight: 500;
}


</style>